var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "puppy.bf3620db.png","uri@2x": __webpack_public_path__ + "puppy.a41906aa.png","uri@3x": __webpack_public_path__ + "puppy.34f6f321.png",
    width: 74,
    height: 92
});